var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"container-authenticated"},[_c('TeliaCoreIcon',{staticClass:"icon",attrs:{"name":"end_user_thin","size":"2rem"}}),_c('div',[_c('div',{staticClass:"username-text"},[_vm._v(_vm._s(_vm.getFullName))]),(_vm.getCompany)?_c('div',{staticClass:"company-text"},[_vm._v(_vm._s(_vm.getCompany))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }